import { VerifyFrom } from "./VerifyFrom";
import { TOP_CNT } from "./constants";
import { Fragment, useEffect, useState, useMemo } from "react";
import { FooterAds } from "../../components/ads/FooterAds";
import { apiMain } from "services";
import "./styles/VerifyPage.scss";

const WAITING_STATUS = "waiting";
const ACCEPTED_STATUS = "accepted";
const APPROVED_STATUS = "approved";

export const VerifyPage = () => {
  const [verifyStatus, setVerifyStatus] = useState<string | null>(null);
  const [isStatusSent, setStatusSent] = useState<boolean>(false);
  const { title, text, verifySentText, verifySuccessText } = TOP_CNT;

  const description = useMemo(() => {
    switch (verifyStatus) {
    case APPROVED_STATUS:
      return verifySuccessText;
    case WAITING_STATUS:
    case ACCEPTED_STATUS:
      return verifySentText;
    default:
      return text;
    }
  }, [verifyStatus, text, verifySentText, verifySuccessText]);

  const fetchUserVerifyStatus = async () => {
    try {
      const { status } = await apiMain.getVerifyUserStatus();
      setVerifyStatus(status);
    } catch (err) {
      console.error(err);
      setVerifyStatus(null);
    }
  };

  const handleStatusSent = (value: boolean) => setStatusSent(value);

  useEffect(() => {
    fetchUserVerifyStatus();
  }, []);

  useEffect(() => {
    if (isStatusSent) {
      fetchUserVerifyStatus();
    }
  }, [isStatusSent]);

  return (
    <Fragment>
      <div className="VerifyPage">
        <div className="VerifyPage-TopCnt">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        {!verifyStatus && <VerifyFrom handleStatusSent={handleStatusSent} />}
      </div>

      <FooterAds/>
    </Fragment>
  );
};
